import * as React from 'react';
import styled from '@emotion/styled';
import { css } from 'emotion';
import { MuiButton, styles as s } from '@onehope/design-system-ohw';
import { container } from './styles';

/* Components */
const { cssConstants } = s;

interface TextBannerProps {
  containerWidth: number;
  handleRouteChange: (input: string) => void;
  config: {
    headerTitle: string;
    summary1: string;
    summary2: string;
    finePrint?: string;
    buttonLink: string;
    buttonText: string;
    useButton?: boolean;
    buttonText2?: string;
    useButton2?: boolean;
    buttonLink2?: string;
    useBorder?: boolean;
  };
}

interface ButtonProps {
  useBothButtons: boolean | undefined;
}

const Button = styled(MuiButton)`
   && {
    width: ${({ useBothButtons }: ButtonProps) =>
      useBothButtons ? `300px` : `288px`};
   }
}
`;

const ButtonContainer = styled.div`
  padding: 12px;
`;

const ButtonFlexContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  max-width: 668px;
  margin: 0 auto;
  @media screen and (min-width: 768px) {
    flex-direction: row;
  }
`;

const FlexContainer = styled.div<any>`
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow-wrap: break-word;
  text-align: center;
  font-size: 18px;
  font-weight: 300;
  line-height: 25px;
  margin: 0 auto;
  border: ${({ useBorder }) => (useBorder ? '1px solid #1a1a1a' : 'none')};
  /* max-width: 668px; */
  max-width: 720px;
  @media screen and (min-width: 320px) {
    max-width: ${({ useBorder }) => (useBorder ? '288px' : '720px')};
  }
  @media screen and (min-width: 768px) {
    max-width: ${({ useBorder }) => (useBorder ? '688px' : '720px')};
  }
  @media screen and (min-width: 1440px) {
    /* max-width: 968px; */
    max-width: ${({ useBorder }) => (useBorder ? '1312px' : '968px')};
  }
`;

const SummaryText = styled.div<any>`
  color: ${cssConstants.textColor};
  /* font-size: 18px; */
  font-size: ${({ useBorder }) => (useBorder ? '14px' : '18px')};
  line-height: 1.44;
  font-weight: 300;
  margin-bottom: 0px;
  @media screen and (min-width: 1440px) {
    font-size: 18px;
  }
`;

const summaryTextBold = css`
  color: ${cssConstants.textColor};
  font-size: 18px;
  line-height: 1.44;
  font-weight: 600;
  margin-bottom: 24px;
`;

const FinePrintText = styled.div<any>`
  color: ${cssConstants.textColor};
  font-size: 14px;
  font-style: italic;
  line-height: 19px;
  font-weight: 300;
  margin-top: 32px;
`;

export const Header = styled.div<any>`
  font-size: ${({ useBorder }) => (useBorder ? '18px' : '32px')};
  /* font-size: 18px; */
  font-weight: bold;
  line-height: 1.31;
  letter-spacing: -0.5px;
  text-align: center;
  padding: ${({ useBorder }) => (useBorder ? '32px 16px 0px' : '0 16px')};
  color: ${cssConstants.textColor};
  font-family: 'Playfair Display', 'proxima-nova', serif;
  margin-bottom: 24px;
  @media screen and (min-width: 768px) {
    /* font-size: 44px; */
    font-size: ${({ useBorder }) => (useBorder ? '18px' : '44px')};
    padding: ${({ useBorder }) => (useBorder ? '40px 40px 0px' : '0 16px')};
    line-height: 1.32;
  }
  @media screen and (min-width: 1440px) {
    /* font-size: 60px; */
    font-size: ${({ useBorder }) => (useBorder ? '32px' : '60px')};
    line-height: 1.33;
    padding: ${({ useBorder }) => (useBorder ? '64px 16px 0px' : '0 16px')};
  }
`;

function createMarkup(summary: string) {
  return { __html: summary };
}

function TextBanner({ config, handleRouteChange }: TextBannerProps) {
  const onClick = () => {
    const { buttonLink } = config;
    handleRouteChange(buttonLink);
  };
  const onClickButton2 = () => {
    const { buttonLink2 } = config;
    handleRouteChange(buttonLink2);
  };
  const {
    headerTitle,
    buttonText,
    buttonText2,
    summary1,
    summary2,
    finePrint,
    useButton,
    useButton2,
    useBorder,
  } = config;

  const useBothButtons = useButton && useButton2;
  const buttonType = useBothButtons ? 'SECONDARY' : 'PRIMARY';
  return (
    <div className={container}>
      <FlexContainer useBorder={!!useBorder}>
        <Header
          useBorder={!!useBorder}
          dangerouslySetInnerHTML={createMarkup(headerTitle)}
        />
        <SummaryText
          useBorder={!!useBorder}
          dangerouslySetInnerHTML={createMarkup(summary1)}
        />
        <span className={summaryTextBold}> {summary2}</span>
      </FlexContainer>
      <ButtonFlexContainer>
        {useButton && (
          <ButtonContainer>
            <Button
              useBothButtons={useBothButtons}
              onClick={onClick}
              type={buttonType}
              fullWidth
            >
              {buttonText}
            </Button>
          </ButtonContainer>
        )}
        {useButton2 && (
          <ButtonContainer>
            <Button
              useBothButtons={useBothButtons}
              onClick={onClickButton2}
              type={buttonType}
              fullWidth
            >
              {buttonText2}
            </Button>
          </ButtonContainer>
        )}
      </ButtonFlexContainer>
      <FinePrintText dangerouslySetInnerHTML={createMarkup(finePrint)} />
    </div>
  );
}

export default TextBanner;
